/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDisconnect = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m16.586 18 5.707 5.707 1.414-1.414-22-22L.293 1.707l6.816 6.817c-.11.153-.211.312-.306.476H2v6h4.803A5.998 5.998 0 0 0 12 18h4.586zm-2-2H12a4 4 0 0 1-3.446-6.032L14.586 16zm-8.503-5a6.04 6.04 0 0 0 0 2H4v-2h2.083zM18 13.773V10h4V8h-4V6h-6c-.542 0-1.067.072-1.567.207L12.227 8H16v3.773l2 2zM20.227 16H22v-2h-3.773l2 2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDisconnect as Disconnect };
